function discovery() {
    const page = document.querySelector('[data-discovery-page]');
    if (!page) return;

    const search = page.querySelector('[data-discovery-search]');
    if (search) {
        const items = Array.from(page.querySelectorAll('[data-discovery-item]'));
        const count = page.querySelector('[data-discovery-count]');
        const empty = page.querySelector('[data-discovery-empty]');
        search.addEventListener('input', () => {
            const terms = search.value.toLowerCase().trim().split(/\s+/).filter(Boolean);
            let visible = 0;
            items.forEach((item) => {
                const match = terms.every((term) => item.dataset.search.includes(term));
                item.hidden = !match;
                if (match) visible += 1;
            });
            count.textContent = `${visible} result${visible === 1 ? '' : 's'}`;
            empty.hidden = visible !== 0;
        });
    }

    const picker = page.querySelector('[data-compare-picker]');
    if (picker) {
        const left = picker.querySelector('[data-compare-left]');
        const right = picker.querySelector('[data-compare-right]');
        const button = picker.querySelector('[data-compare-submit]');
        const error = picker.querySelector('[data-compare-error]');
        button.addEventListener('click', () => {
            if (left.value === right.value) {
                error.hidden = false;
                return;
            }
            error.hidden = true;
            window.location.assign(`${button.dataset.base}${encodeURIComponent(left.value)}/vs/${encodeURIComponent(right.value)}/`);
        });
    }
}

function profileHeroVideo() {
    const media = document.querySelector('[data-profile-hero-media]');
    if (!media) return;

    const video = media.querySelector('[data-profile-hero-video]');
    if (!video) return;

    const showVideo = () => media.classList.add('is-video-playing');
    const discardVideo = () => {
        media.classList.remove('is-video-playing');
        video.remove();
    };

    video.defaultMuted = true;
    video.muted = true;
    video.addEventListener('playing', showVideo);
    video.addEventListener('error', discardVideo);
    video.querySelector('source')?.addEventListener('error', discardVideo);

    const playback = video.play();
    if (playback) playback.catch(discardVideo);
}

function characterProfileActions() {
    const profile = document.querySelector('[data-character-profile]');
    if (!profile) return;

    profile.querySelectorAll('[data-character-action]').forEach((action) => {
        action.addEventListener('click', () => {
            if (typeof window.gaTrack !== 'function') return;

            const destination = action.dataset.characterDestination || 'unknown';
            const eventType = destination === 'talkiemate'
                ? 'character_profile_talkiemate_handoff'
                : 'character_profile_generator_click';

            window.gaTrack(eventType, {
                object_id: profile.dataset.characterSlug || '',
                object_type: 'character_profile',
                metadata: {
                    character_name: profile.dataset.characterName || '',
                    action: action.dataset.characterAction || '',
                    destination,
                    placement: action.dataset.characterPlacement || '',
                    source_platform: profile.dataset.characterSource || '',
                },
            });
        });
    });
}

function toolsDirectory() {
    const page = document.querySelector('[data-tools-page]');
    if (!page) return;
    const cards = Array.from(page.querySelectorAll('[data-tool-card]'));
    const search = page.querySelector('[data-tools-search]');
    const buttons = Array.from(page.querySelectorAll('[data-tools-filter]'));
    const quickButtons = Array.from(page.querySelectorAll('[data-quick-filter]'));
    const count = page.querySelector('[data-tools-count]');
    const empty = page.querySelector('[data-tools-empty]');
    let category = 'all';

    const update = () => {
        const terms = search ? search.value.toLowerCase().trim().split(/\s+/).filter(Boolean) : [];
        let visible = 0;
        cards.forEach((card) => {
            const categoryMatch = category === 'all' || card.dataset.categories.split('|').includes(category);
            const searchMatch = terms.every((term) => card.dataset.search.includes(term));
            card.hidden = !(categoryMatch && searchMatch);
            if (!card.hidden) visible += 1;
        });
        if (count) count.textContent = `${visible} platform${visible === 1 ? '' : 's'}`;
        if (empty) empty.hidden = visible !== 0;
    };
    if (search) search.addEventListener('input', update);
    buttons.forEach((button) => button.addEventListener('click', () => {
        category = button.dataset.toolsFilter;
        buttons.forEach((item) => item.setAttribute('aria-pressed', item === button ? 'true' : 'false'));
        update();
    }));
    quickButtons.forEach((button) => button.addEventListener('click', () => {
        const target = button.dataset.quickFilter;
        const filter = buttons.find((item) => item.dataset.toolsFilter === target);
        if (filter) filter.click();
        document.querySelector('#platform-directory')?.scrollIntoView({behavior: 'smooth', block: 'start'});
    }));
}

function charactersDirectory() {
    const page = document.querySelector('[data-characters-page]');
    if (!page) return;
    const cards = Array.from(page.querySelectorAll('[data-character-card]'));
    const search = page.querySelector('[data-character-search]');
    const platform = page.querySelector('[data-character-platform]');
    const gender = page.querySelector('[data-character-gender]');
    const style = page.querySelector('[data-character-style]');
    const sort = page.querySelector('[data-character-sort]');
    const count = page.querySelector('[data-character-count]');
    const empty = page.querySelector('[data-character-empty]');
    const reset = page.querySelector('[data-character-reset]');
    const pagination = page.querySelector('[data-character-pagination]');
    const pageList = page.querySelector('[data-character-page-list]');
    const previous = page.querySelector('[data-character-page-prev]');
    const next = page.querySelector('[data-character-page-next]');
    const pageStatus = page.querySelector('[data-character-page-status]');
    const itemLabel = page.dataset.directoryItemLabel || 'character';
    const itemLabelPlural = page.dataset.directoryItemLabelPlural || `${itemLabel}s`;
    const pageParam = page.dataset.directoryPageParam || 'character_page';
    const pageSize = Number(page.dataset.directoryPageSize) || 25;
    const total = Number(page.dataset.directoryTotal) || 0;
    const filterParams = [
        {control: search, key: 'q', defaultValue: ''},
        {control: platform, key: 'platform', defaultValue: 'all'},
        {control: gender, key: 'gender', defaultValue: 'all'},
        {control: style, key: 'style', defaultValue: 'all'},
        {control: sort, key: 'sort', defaultValue: 'featured'},
    ].filter(({control}) => control);
    const initialUrl = new URL(window.location.href);
    const currentPage = Number(page.dataset.directoryPage) || Number(initialUrl.searchParams.get(pageParam)) || 1;
    const navigate = (targetPage = 1) => {
        const url = new URL(window.location.href);
        filterParams.forEach(({control, key, defaultValue}) => {
            const value = control.value.trim();
            if (value && value !== defaultValue) url.searchParams.set(key, value);
            else url.searchParams.delete(key);
        });
        if (targetPage > 1) url.searchParams.set(pageParam, targetPage);
        else url.searchParams.delete(pageParam);
        window.location.assign(url.toString());
    };

    cards.forEach((card) => {
        const video = card.querySelector('[data-character-preview-video]');
        if (!video) return;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const startPreview = () => {
            if (reducedMotion.matches || card.hidden) return;
            if (!video.src) video.src = video.dataset.src;
            video.play().then(() => card.classList.add('is-video-playing')).catch(() => {});
        };
        const stopPreview = () => {
            video.pause();
            video.currentTime = 0;
            card.classList.remove('is-video-playing');
        };
        if (window.matchMedia('(hover: hover)').matches) {
            card.addEventListener('pointerenter', startPreview);
            card.addEventListener('pointerleave', () => {
                if (!card.matches(':focus-within')) stopPreview();
            });
        }
        card.addEventListener('focusin', startPreview);
        card.addEventListener('focusout', (event) => {
            if (!card.contains(event.relatedTarget)) stopPreview();
        });
        video.addEventListener('error', () => {
            stopPreview();
            video.remove();
        });
        reducedMotion.addEventListener?.('change', (event) => {
            if (event.matches) stopPreview();
        });
    });

    const renderPagination = () => {
        const pageCount = Math.ceil(total / pageSize);
        pagination.hidden = pageCount <= 1;
        previous.disabled = currentPage === 1;
        next.disabled = currentPage === pageCount;
        pageList.replaceChildren();
        const pageNumbers = pageCount <= 7
            ? Array.from({length: pageCount}, (_, index) => index + 1)
            : Array.from(new Set([
                1,
                currentPage - 1,
                currentPage,
                currentPage + 1,
                pageCount,
            ].filter((number) => number >= 1 && number <= pageCount))).sort((a, b) => a - b);

        pageNumbers.forEach((number, index) => {
            if (index && number - pageNumbers[index - 1] > 1) {
                const ellipsis = document.createElement('span');
                ellipsis.className = 'art-characters__pagination-ellipsis';
                ellipsis.textContent = '…';
                ellipsis.setAttribute('aria-hidden', 'true');
                pageList.appendChild(ellipsis);
            }
            const button = document.createElement('button');
            button.type = 'button';
            button.textContent = number;
            button.setAttribute('aria-label', `${itemLabel} page ${number}`);
            if (number === currentPage) button.setAttribute('aria-current', 'page');
            button.addEventListener('click', () => navigate(number));
            pageList.appendChild(button);
        });
        const start = total ? ((currentPage - 1) * pageSize) + 1 : 0;
        const end = Math.min(currentPage * pageSize, total);
        const format = new Intl.NumberFormat().format;
        pageStatus.textContent = total ? `Showing ${format(start)}–${format(end)} of ${format(total)} ${itemLabelPlural}` : '';
    };

    count.textContent = new Intl.NumberFormat().format(total);
    empty.hidden = cards.length !== 0;
    reset.hidden = !search.value.trim()
        && (!platform || platform.value === 'all')
        && gender.value === 'all'
        && style.value === 'all'
        && sort.value === 'featured';
    renderPagination();

    let searchTimer;
    search?.addEventListener('input', () => {
        window.clearTimeout(searchTimer);
        searchTimer = window.setTimeout(() => navigate(1), 350);
    });
    [platform, gender, style, sort].filter(Boolean).forEach((control) => control.addEventListener('change', () => navigate(1)));
    previous.addEventListener('click', () => {
        if (currentPage > 1) navigate(currentPage - 1);
    });
    next.addEventListener('click', () => {
        if (currentPage < Math.ceil(total / pageSize)) navigate(currentPage + 1);
    });
    reset.addEventListener('click', () => {
        search.value = '';
        if (platform) platform.value = 'all';
        gender.value = 'all';
        style.value = 'all';
        sort.value = 'featured';
        navigate(1);
    });
}

function mediaHubVideos() {
    const videos = Array.from(document.querySelectorAll('video[data-public-video]'));
    const load = (video) => {
        if (!video.dataset.src) return;
        const status = video.parentElement.querySelector('[data-video-status]');
        video.addEventListener('loadeddata', () => { if (status) status.hidden = true; }, {once: true});
        video.addEventListener('error', () => {
            if (status) {
                status.hidden = false;
                status.textContent = 'Video unavailable. Please try again later.';
            }
        }, {once: true});
        video.preload = 'auto';
        video.src = video.dataset.src;
        delete video.dataset.src;
        video.load();
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            load(entry.target);
            observer.unobserve(entry.target);
        });
    }, {rootMargin: '320px'}) : null;
    videos.forEach((video, index) => {
        if (index < 3 || !observer) load(video);
        else observer.observe(video);
    });
}

export {characterProfileActions, discovery, toolsDirectory, charactersDirectory, mediaHubVideos, profileHeroVideo};
